// extracted by mini-css-extract-plugin
export default {"table":"styles_table__v3LuU","link":"styles_link__NFudZ"};